<script>
  import { clusterTypes, selectedClusterType } from './stores.js'
</script>

<style>
  .button {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: #aaaaaa;
  }
  .button:hover {
    text-decoration: underline;
  }
  .button.selected {
    text-decoration: underline;
    color: #ffffff;
  }
  .label {
    margin: 5px;
    color: #aaaaaa;
  }
</style>

<div>
  <div class="label">CLUSTER ON</div>
  {#each clusterTypes as type}
    <div class="button"
      class:selected="{type === $selectedClusterType}"
      on:click={() => {
        $selectedClusterType = type
      }}>
      {type.label.toLowerCase()}
    </div>
  {/each}
</div>
